import { Box } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import Logo from "../assets/logo.png";
import CustomButtons from "../helpercomponents/CustomButtons";
import appstore from "../store/appstore";
const Navbar = () => {
  const [isMobileview, setIsMobileView] = useState(false);
  const { setMenu, menu } = appstore();
  const navigate = useNavigate();
  React.useEffect(() => {
    if (window && window.innerWidth) {
      if (window.innerWidth < 930) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    }
    const updateScreenWidth = () => {
      if (window.innerWidth < 930) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    };
    window.addEventListener("resize", updateScreenWidth);
    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);
  return (
    <Box
      width={"100%"}
      position={"sticky"}
      style={{ background: "white" }}
      background={"white"}
      top={"0"}
      zIndex={100}
      paddingTop={isMobileview ? "12px" : "37px"}
      boxShadow={'rgba(0, 0, 0, 0.09) 0px 3px 12px'}
    >
      <Box
        width={"100%"}
        display={"flex"}
        flexDirection={isMobileview ? "column" : "row"}
        justifyContent={"space-around"}
      >
        <Box
          style={{
            display: isMobileview ? "flex" : "",
            width: isMobileview ? "100%" : "40%",
            // border: "1px solid red",
            justifyContent: isMobileview ? "center" : "",
          }}
        >
          <img
            src={Logo}
            style={{
              cursor: "pointer",
              width: isMobileview ? "93px" : "177px",
              height: isMobileview ? "18px" : "36px",
            }}
            onClick={() => {
              setMenu("");
              navigate("/")
            }}
          />
        </Box>
        <Box
          display={"flex"}
          gap="3%"
          paddingBottom={!menu ? "15px" : "0px"}
          style={{
            width: isMobileview ? "100%" : "40%",
            justifyContent: isMobileview ? "center" : "",
            height: "56px",
            marginTop: isMobileview ? "20px" : "0px",
          }}
          // boxShadow={isMobileview ? 'rgba(0, 0, 0, 0.09) 0px 3px 12px' : 0}
        >
          <CustomButtons
            variant={menu == "Newsletters" ? "contained" : "outlined"}
            title={"Newsletters"}
            id='buttontest'
            handleFunc={() => {
              console.log("sdsdfsdfsfd")
              setMenu("Newsletters");
              navigate("/newsletters")

            }}
            isDisabled={false}
            isMobileview={isMobileview}
          />
          <CustomButtons
            variant={menu == "Podcast" ? "contained" : "outlined"}
            title={"Podcast"}
            handleFunc={() => {
              setMenu("Podcast");
              navigate("/podcast");
            }}
            isDisabled={false}
            isMobileview={isMobileview}
          />
          <CustomButtons
            variant={menu == "Sources" ? "contained" : "outlined"}
            title={"Sources"}
            handleFunc={() => {
              setMenu("Sources");
              navigate("/sources")
            }}
            isDisabled={false}
            isMobileview={isMobileview}
          />
        </Box>
      </Box>
      <Box
        display={isMobileview || !menu ? "none" : "block"}
        // border={"1px solid red"}
        height={"73px"}
        fontSize={"48px"}
        fontWeight={500}
        paddingLeft={"5%"}
        boxShadow={1}
        // style={{background:}}
        // background={"white"}
        // top={"0"}
        // zIndex={100}
      >
        {menu}
      </Box>
    </Box>
  );
};

export default Navbar;
